document.addEventListener("DOMContentLoaded", function () {
    const mButton = document.querySelector(".m_button");
    const hamBurgerMenu = document.querySelector(".hamBurger-menu");
    const mButtonSpan = document.querySelectorAll(".m_button span");
    const masthead = document.getElementById('masthead');

    if (document.querySelectorAll('.nav-white').length > 0) {
        masthead.classList.add('header-white');
    }

    const updateButtonColor = () => {
        const isBgWhite = masthead.classList.contains('bg-white');
        const isHeaderWhite = masthead.classList.contains('header-white');
        const color = (isBgWhite || isHeaderWhite) ? "black" : "white";
        updateButtonBackground(color);
    };

    mButton.addEventListener("click", function () {
        hamBurgerMenu.classList.toggle("open-menu");
        mButton.classList.toggle("menu-drop");

        document.body.style.overflow = hamBurgerMenu.classList.contains("open-menu") ? "hidden" : "auto";
        updateButtonColor();
    });

    const handleScroll = () => {
        requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            const hasScrolled = scrollY > 10;

            if (hasScrolled) {
                masthead.classList.add('bg-white');
            } else {
                masthead.classList.remove('bg-white');
            }
            updateButtonColor();
        });
    };

    function updateButtonBackground(color) {
        mButtonSpan.forEach((button) => {
            button.style.background = color;
        });
    }

    window.addEventListener('scroll', handleScroll);


    let selectOption = document.getElementById("Product-Type");
    let padMountSection = document.querySelector(".transformer");
    let otherTypeSection = document.querySelector(".others");
    
    console.log('selectOption: ', selectOption);
    if(selectOption){
        selectOption.addEventListener('change', function() {
            let optionValue = selectOption.value;
        
            if (optionValue === "Transformer") {
                padMountSection.style.display = "block";  
                otherTypeSection.style.display = "none"; 
        
        
            } else if (optionValue !== "Transformer") {
                padMountSection.style.display = "none"; 
                otherTypeSection.style.display = "block"; 
        
            } 
        });
    }
   
    

});

function getHeaderBackground(className) {
    const masthead = document.getElementById('masthead');
    const hasClass = masthead.classList.contains(className);
    console.log(`Masthead has '${className}': ${hasClass}`);
    return hasClass ? "black" : "white";
}

document.addEventListener('click', function (event) {
    const dropdowns = document.querySelectorAll('.dropdown-menu');
    const productsServicesLinks = document.querySelectorAll('#products-services');

    dropdowns.forEach(dropdown => {
        if (!dropdown.contains(event.target) && !Array.from(productsServicesLinks).some(link => link.contains(event.target))) {
            dropdown.style.height = "0px";
        }
    });
});

//---------- Homepage Banner Slider ------------//`
document.addEventListener("DOMContentLoaded", () => {
    var heroBannerSlider = document.querySelector('.hero-banner-slider');
    if (heroBannerSlider) {
        const heroSplide = new Splide('.hero-banner-slider', {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            autoplay: true,
            interval: 6000,
            speed: 1000,
            pagination: false,
            arrows: false,
            pauseOnHover: false,
        });

        heroSplide.mount();

        // const progressBars = [
        //     document.querySelector('#progressBar1'),
        //     document.querySelector('#progressBar2'),
        //     document.querySelector('#progressBar3')
        // ];
        // const progressTexts = [
        //     "Your partner for power grid solutions",
        //     "Powering American energy and industry",
        //     "Quality manufacturing you can trust"
        // ];
        // const autoplayInterval = 6000;

        // if(progressBars && progressTexts){
        //     const startProgressBar = (index) => {
        //         progressBars.forEach((bar, i) => {
        //             const progress = bar.querySelector('.progress');
        //             const textElement = bar.querySelector('.progress-text');
        //             progress.style.transition = 'none';
        //             progress.style.width = '0%';
    
        //             bar.classList.remove('active');
    
        //             if (i === index) {
        //                 setTimeout(() => {
        //                     progress.style.transition = `width ${autoplayInterval}ms linear`;
        //                     progress.style.width = '100%';
        //                     bar.classList.add('active');
        //                 }, 100);
        //             }
        //         });
        //     };
    
        // }

        // heroSplide.on('autoplay:play', () => startProgressBar(heroSplide.index));
        // heroSplide.on('move', (newIndex) => {
        //     startProgressBar(newIndex);
        //     updateProgressText(newIndex);
        // });

        // const updateProgressText = (index) => {
        //     progressBars.forEach((bar, i) => {
        //         const textElement = bar.querySelector('.progress-text');
        //         if (textElement) {
        //             textElement.textContent = progressTexts[i];
        //         }
        //     });
        // };

        // startProgressBar(heroSplide.index);
        // updateProgressText(heroSplide.index);

        // progressBars.forEach((bar, index) => {
        //     bar.addEventListener('click', () => {
        //         heroSplide.go(index);
        //     });
        // });

        // heroSplide.on('move', (newIndex) => {
        //     const currentSlide = heroSplide.Components.Slides.getAt(newIndex);
        //     const imgElement = currentSlide.slide.querySelector('.zoominheader img');

        //     document.querySelectorAll('.zoominheader img').forEach(img => {
        //         img.classList.remove('zoom-in');
        //         void img.offsetWidth;
        //     });

        //     imgElement.classList.add('zoom-in');
        // });

        const initialSlide = heroSplide.Components.Slides.getAt(heroSplide.index);
        const initialImgElement = initialSlide.slide.querySelector('.zoominheader img');
        initialImgElement.classList.add('zoom-in');
    }
});

//---------- Testimonial Slider ----------//
document.addEventListener("DOMContentLoaded", function () {
    var splide_one = document.querySelector(".splide_one");
    if (splide_one != null && splide_one) {
        new Splide(splide_one, {
            type: "loop",
            perPage: 1,
            gap: "20px",
            pagination: true,
            autoplay: false,
            arrows: false,
            focus: 'center',
            autoScroll: {
                speed: 2,
            },
            breakpoints: {
                767: {
                    perPage: 1,
                    perMove: 1,
                    arrows: false,
                    gap: "20px",
                },
                481: {
                    perPage: 1,
                    perMove: 1,
                    arrows: false,
                    gap: "20px",
                },
            },
        }).mount();
    }
});

// ----------------------- mega menu --------------------///
const menu = document.querySelector(".services");
const megaMenu = document.querySelector(".mega-menu");
const header = document.querySelector(".header");
const menuHide = document.querySelector(".menu-hide");
const overlay = document.getElementById("overlay");

const toggleMenu = (isActive) => {
    megaMenu.classList.toggle("active", isActive);
    overlay.classList.toggle("active", isActive);

    setTimeout(() => {
        if (isActive) {
            header.classList.add("bg-white");
        } else {
            if (!megaMenu.classList.contains("active")) {
                header.classList.remove("bg-white");
            }
        }
    }, isActive ? 0 : 300);
};

menu.addEventListener("mouseenter", () => {
    toggleMenu(true);
});

menuHide.addEventListener("mouseenter", () => {
    toggleMenu(false);
});

megaMenu.addEventListener("mouseleave", () => {
    toggleMenu(false);
});


// ------------------- Tabs ------------------//

const tabs = document.querySelectorAll('.tab-menu li');
const tabContents = document.querySelectorAll('.tab-items');

tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('tab-active'));
        tab.classList.add('tab-active');

        tabContents.forEach(content => content.style.display = 'none');
        tabContents[index].style.display = 'block';
    });
});

tabContents.forEach((content, index) => {
    content.style.display = index === 0 ? 'block' : 'none';
});

// --------------- Accordion ------------------//

var accordions = document.querySelectorAll(".accordion__item--header");

if (accordions !== null) {
    accordions.forEach(header => {
        header.addEventListener('click', () => {
            const accordionItem = header.closest('.accordion__item');
            const accordionContent = accordionItem.querySelector('.accordion__item--content');

            document.querySelectorAll('.accordion__item').forEach(item => {
                if (item !== accordionItem && item.classList.contains('active')) {
                    item.classList.remove('active');
                    item.querySelector('.accordion__item--content').style.maxHeight = 0;
                }
            });

            accordionItem.classList.toggle('active');
            if (accordionItem.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
            } else {
                accordionContent.style.maxHeight = 0;
            }
        });
    });

    // Initially set the first accordion item as active
    const firstAccordionItem = document.querySelector('.accordion__item');
    if(firstAccordionItem){
        const firstAccordionContent = firstAccordionItem.querySelector('.accordion__item--content');
        firstAccordionItem.classList.add('active');
        firstAccordionContent.style.maxHeight = firstAccordionContent.scrollHeight + 'px';
    }
}



document.addEventListener('DOMContentLoaded', function () {
    //         transformer mobile slider     //
    
    var mobileSliderElements = document.querySelectorAll('.mobile-slider');
    mobileSliderElements.forEach(function (mobileSliderElement) {
        if (mobileSliderElement) {

            var splide_two = new Splide(mobileSliderElement, {
                type: 'loop',
                arrows: false,
                pagination: false,
                perPage: 1,
                drag : true,
                focus: 'center',
                breakpoints: {
                    768: {
                        perPage: 1.5    ,
                        gap: "20px",
                    }
                }
            });
            splide_two.mount();
        }
    });
    var baseSlider = document.querySelector('.base-image-slider');
    if (baseSlider) {
        var splide_three = new Splide(baseSlider, {
            type: 'loop',
            arrows: false,
            pagination: true,
            perPage: 3,
            gap: "20px", 
            autoplay: true,  
            interval: 3000,  
            focus: 'center',
            breakpoints: {
                768: {
                    perPage: 1.5,
                    gap: "20px"  
                }
            }
        });
        splide_three.mount();
    }
});


///     pop up function   //
function openPopup() {
    document.getElementById('popup').style.display = 'flex';
}


document.addEventListener('DOMContentLoaded', () => {

        let customFileInput = document.querySelector('#custom-file-input');
        
        if (customFileInput) {
            customFileInput.addEventListener('change', function (event) {
                const file = event.target.files[0];  
                const cf7FileInput = document.querySelector('[name="upload-files"]');  
                const chooseFilesText = document.querySelector('.custom-file-upload .sec-font');
    
                if (chooseFilesText) {
                    // Check if the CF7 file input is present
                    if (cf7FileInput) {
                        // Create a DataTransfer object to manipulate files
                        const dataTransfer = new DataTransfer();
                        if (file) {
                            dataTransfer.items.add(file);  
                            cf7FileInput.files = dataTransfer.files;  
                        } else {
                            cf7FileInput.files = new DataTransfer().files; 
                        }
                    }
    
                    // Update the displayed text with the file name
                    if (file) {
                        chooseFilesText.textContent = file.name; 
                    } else {
                        chooseFilesText.textContent = "Choose Files";  
                    }
                }
            });
        }

    

// Close popup for all popups
let closeButtons = document.querySelectorAll('.close-popup');
let popupOverlays = document.querySelectorAll('.popup-overlay');

closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
        // Find the closest popup and hide it
        let popup = button.closest('.popup-overlay');
        if (popup) {
            popup.style.display = 'none';
        }
    });
});

popupOverlays.forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
        // Close only if the overlay itself is clicked (not the content inside)
        if (event.target.classList.contains('popup-overlay')) {
            overlay.style.display = 'none';
        }
    });
});



 // Open Popup for Switchgear
 document.getElementById('openPopupSwitchgear').addEventListener('click', function () {
    document.getElementById('popup-switchgear').style.display = 'block';
  });

  // Close Popup for Switchgear
  document.getElementById('closePopupSwitchgear').addEventListener('click', function () {
    document.getElementById('popup-switchgear').style.display = 'none';
  });

  // Open Popup for Substation Equipment
  document.getElementById('openPopupSubstation').addEventListener('click', function () {
    document.getElementById('popup-substation').style.display = 'block';
  });

  // Close Popup for Substation Equipment
  document.getElementById('closePopupSubstation').addEventListener('click', function () {
    document.getElementById('popup-substation').style.display = 'none';
  });
});

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    if (header.classList.contains('header-white') || header.classList.contains('bg-white')) {
        const spans = document.querySelectorAll('.header .m_button span');
        spans.forEach(span => {
            span.style.backgroundColor = '#000';
        });
    }
});

//    career   gallery slider  //
document.addEventListener('DOMContentLoaded', function () {
    var gallerySlider = document.querySelector('.career-gallery-slider');
    
    if (gallerySlider) {
        new Splide(gallerySlider, {
            type       : 'loop',
            perPage    : 1.5,
            autoplay   : false,
            pagination : false,
            arrows     : false,
            focus: 'center',
            gap        : '20px' 
        }).mount();
    }
});



const tabss = document.querySelectorAll('.tab-menu li');

const handleTabClick = (event) => {
  const clickedTab = event.currentTarget;

  tabss.forEach(tab => tab.classList.remove('tab-active'));

  clickedTab.classList.add('tab-active');

  clickedTab.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

  console.log(`Active tab: ${clickedTab.dataset.tab}`);
};

tabss.forEach(tab => {
  tab.addEventListener('click', handleTabClick);
});

const options = {
  root: null,
  threshold: 0.5
};

const callback = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      console.log(`Current tab in viewport: ${entry.target.dataset.tab}`);
    }
  });
};

const observer = new IntersectionObserver(callback, options);
tabss.forEach(tab => observer.observe(tab));




document.querySelectorAll('.job').forEach(jobElement => {
    const jobTitle = jobElement.querySelector('.job-title p').innerText; 
    const applyButton = jobElement.querySelector('.apply-btn a'); 
    applyButton.href = `/ayr-energy/careers/apply-now/?designation=${encodeURIComponent(jobTitle)}`; 
});

// Check if on the apply-now page
if (window.location.pathname === '/ayr-energy/careers/apply-now/') {
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Get the job designation from the URL
    const jobDesignation = getQueryParam('designation');

    if (jobDesignation) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = 'job_designation'; 
        hiddenField.value = jobDesignation;

        const form = document.querySelector('.wpcf7 form');
        if (form) {
            form.appendChild(hiddenField);
        }
    }
}
